import React, { useEffect, useState } from 'react'
import ExploreCourses from '../../../ExploreCourses'
import { courseLimit } from '../../../../../env'
import ExploreCoursesHome from '../../../ExploreCoursesHome'
import useWindowDimensions from '../../../../../utils/useWindowDimensions'

const ExploreCategory = () => {
    let {width , height} = useWindowDimensions()
    const [atHome, setAtHome] = useState(true)


    return (
        <>
            <section className="expcategory">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 position-relative">
                            <h3 className='heading'> <span style={{ whiteSpace: 'nowrap' }}>Explore Categories</span> <span className='linev'></span></h3>
                        </div>
                    </div>
                    <ExploreCoursesHome  screenSize={  width > 1700 ? "large" : ( width > 1000 ? "medium" : ( width > 800 ? "small" : "extrasmall" ) )  } atHome={atHome} />
                </div>
            </section>
        </>
    )
}

export default ExploreCategory
